var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c(
        "el-aside",
        { staticStyle: { "margin-bottom": "20px" }, attrs: { width: "140px" } },
        [_c("sidebarA", { staticClass: "sidebar-container" })],
        1
      ),
      _vm._v(" "),
      _c(
        "el-container",
        [
          !_vm.isInIframe
            ? _c(
                "el-header",
                { staticClass: "header" },
                [
                  _c("navbar", {
                    staticClass: "navbar",
                    attrs: { nameshow: _vm.nameshow },
                    on: { helpcenterEvent: _vm.showhelp },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("el-main", { style: _vm.isInIframe ? "margin-top: 0" : "" }, [
            _c(
              "div",
              {
                staticClass: "main-container",
                class: { hasTagsView: _vm.needTagsView },
              },
              [
                _c("div", { class: { "fixed-header": _vm.fixedHeader } }, [
                  _c(
                    "div",
                    { staticStyle: { margin: "10px 0 0 10px" } },
                    [
                      _vm.needTagsView ? _c("tags-view") : _vm._e(),
                      _vm._v(" "),
                      _c("app-main"),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.showSettings ? _c("right-panel", [_c("settings")], 1) : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }